import PortalIdParser from 'PortalIdParser';
import { APP } from 'pricing-pages-ui/constants/tracking/App';
import events from 'pricing-pages-ui/events.yaml';
import Raven from 'raven-js';
import { getDeviceId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
import { createContainer } from 'usage-tracker-multi';
// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { getAnonymousDeviceId } from './trackingUtils';
const CATEGORY_PREFERENCES_COOKIE = '__hs_cookie_cat_pref';
const OPT_OUT_COOKIE = '__hs_opt_out';
const hasAcceptedCookies = () => {
  var _Cookies$get;
  return getUtk() && (Cookies.get() && ((_Cookies$get = Cookies.get(CATEGORY_PREFERENCES_COOKIE)) === null || _Cookies$get === void 0 ? void 0 : _Cookies$get.includes('1:true')) || Cookies.get(OPT_OUT_COOKIE) === 'no');
};
const getTrackerType = () => {
  if (PortalIdParser.get()) {
    return 'authed';
  }
  if (hasAcceptedCookies()) {
    return 'public';
  }
  return 'anonymous';
};
const {
  createTracker
} = createContainer({
  storeUuidOnUrl: false
});
export const lastKnownEventProperties = ['screen', 'subscreen', 'tab', 'isSeatsPilot'];
const commonTrackerProperties = {
  events,
  properties: {
    namespace: APP,
    hstc: () =>
    // If the UTK cookie is defined we use it, otherwise we fallback to the anonymous ID provided by Laboratory
    // Since an instance here is recreated whenever the UTK cookie becomes present or is removed
    // This method is accurate to resolve the HSTC when the cookie is present or resolve the anonymous ID
    `x.${hasAcceptedCookies() ? getUtk() : getAnonymousDeviceId()}`
  },
  lastKnownEventProperties: [...lastKnownEventProperties],
  // https://product.hubteam.com/docs/usage-tracking-manual/docs/frontend/tracker-api.html#field-onerror
  onError: (err, options = {}) => {
    Raven.captureException(err, Object.assign({}, options));
  }
};

/**
 * Creates a usage tracker.
 *
 * @param opts - Optional parameters for creating the tracker.
 * @param opts.events - We can create a tracker tied to a different namespace/yaml file by passing in the events object here. By default, it uses `pricing-pages-ui/events.yaml`.
 * @returns The created usage tracker.
 */
export const createUsageTracker = opts => {
  return createTracker(Object.assign({}, commonTrackerProperties, {
    trackerType: getTrackerType()
  }, opts, {
    onBeforeSwitch: ({
      to
    }) => {
      // We expose the anonymous device id to window for allowing other apps to consume it
      // If we are on anonymous mode we use the Laboratory Identifier (and update the storage to use it)
      // since that's what we should be using for anonymous IDs.
      // But when switching to non-anonymous mode we use the newly generated Amplitude Device ID
      window.__utAnonId =
      // Attempts to retrieve Laboratory's Anonymous Identifier (if available)
      // otherwise fallbacks to a generated Device ID
      to === 'anonymous' ? getAnonymousDeviceId() : getDeviceId();
    }
  }));
};